import { inject, computed, ref, watch } from 'vue'

export function useSlots() {
    const slots = inject('slots', ref([]))
    const slot = inject('slot', ref(null))
    const current = computed(() => {
        return slots.value?.find(item => item.id === slot.value)
    })

    watch(current, function (current) {
        if (!current && slots.value.length) {
            slot.value = slots.value[0].id
        }
    }, { immediate: true })

    return {
        slot,
        slots,
        current
    }
}